import React from "react";
import { useParams } from "react-router-dom";
import { Field } from "formik";
import { ReactstrapInput, ReactstrapSelect } from "reactstrap-formik";
import * as Yup from "yup";
import { Row, Col } from "reactstrap";
import CrudEdit from "../Crud/Edit";
import service from "core/api/ElevatorService";
import { PbxGroupSelectorInputComponent } from "./PbxGroupSelectorInputComponent";
import { paths } from "utils/PathService";

const BILLING_LINE_TYPES = [
  { value: "Intercom", label: "Intercom" },
  { value: "Elevator", label: "Elevator" },
  { value: "AreaOfRefuge", label: "Area of Refuge" },
  { value: "EmergencyPhone", label: "Emergency Phone" },
];

const DeviceSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  phoneNumber: Yup.string().required("Required"),
  billingLineType: Yup.string().nullable().oneOf(
    [null, ...BILLING_LINE_TYPES.map(type => type.value)],
    "Select a valid line service"
  ),
  billingVideo: Yup.boolean(),
  billingCallCenter: Yup.boolean(),
});

const Edit = () => {
  let { customerId, buildingId } = useParams();
  const isCompanyOwned = !customerId;
  const initialData = {
    id: null,
    customerId: isCompanyOwned ? null : customerId,
    buildingId,
    name: "",
    phoneNumber: "",
    billingLineType: null,
    billingVideo: false,
    billingCallCenter: false,
    doNotCall: isCompanyOwned,
    doNotCheckOnlineStatus: isCompanyOwned,
    excludeFromDailyReports: isCompanyOwned,
  };

  return (
    <>
      <CrudEdit
        title="Elevators"
        initData={initialData}
        crudService={service}
        validationSchema={DeviceSchema}
        getRedirectPath={(id) => paths.elevator.view(id)}>

        <Field name="customerId" >
          {({ form }) => {
            const isCompanyOwned = !String(form.values.customerId ?? "").trim();
            return (
              <>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="name"
                      label="Name"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="phoneNumber"
                      label="Phone Number"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="serialNumber"
                      label="Elevator Id"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>

                {!isCompanyOwned && (
                  <Row>
                    <Col>
                      <label>
                        Is Billing
                        <Field
                          type="checkbox"
                          name="isBilling"
                          component={ReactstrapInput}
                        />
                      </label>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col>
                    <Field
                      type="datetime-local"
                      name="installationDate"
                      label="Installation Date"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="location"
                      label="Device Location"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="boardSerialNumber"
                      label="Phone Board S/N"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name="deviceType"
                      label="Device Type"
                      as="select"
                      component={ReactstrapSelect}
                      inputprops={{
                        name: "deviceType",
                        id: "deviceType",
                        options: ["Elevator", "Phone", "Intercom", "Pool Phone"],
                        defaultOption: "Elevator",
                      }}></Field>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      type="text"
                      name="motorRoomLocation"
                      label="Motor Room Location"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>

                {!isCompanyOwned && (
                  <>
                    <Row>
                      <Col>
                        <label>
                          <Field
                            type="checkbox"
                            name="onlyLineTest"
                            component={ReactstrapInput}
                          />
                          Only Line Test
                        </label>
                      </Col>
                      <Col>
                        <label>
                          <Field
                            type="checkbox"
                            name="doNotCall"
                            component={ReactstrapInput}
                          />
                          Don't call device
                        </label>
                      </Col>
                      <Col>
                        <label>
                          <Field
                            type="checkbox"
                            name="doNotCheckOnlineStatus"
                            component={ReactstrapInput}
                          />
                          Don't check online status
                        </label>
                      </Col>
                      <Col>
                        <label>
                          <Field
                            type="checkbox"
                            name="excludeFromDailyReports"
                            component={ReactstrapInput}
                          />
                          Exclude from daily reports & troubleshooting dashboard
                        </label>
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: 20 }}>
                      <Col>
                        <Field
                          type="text"
                          name="pbxGroup"
                          label="Pbx Group"
                          component={PbxGroupSelectorInputComponent}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <Field
                      type="text"
                      name="callPauseLength"
                      label="Call Pause Length"
                      component={ReactstrapInput}
                    />
                  </Col>
                  <Row style={{ marginTop: 10 }}>
                    <Col>
                      <Field
                        type="text"
                        name="dtmfDigitsForDisconnect"
                        label="DTMF Digits For Disconnect"
                        component={ReactstrapInput}
                      />
                    </Col>
                  </Row>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col md="3">
                    <label style={{ fontSize: 16 }}>
                      <Field
                        type="checkbox"
                        name="callCenterEnabled"
                      />
                      {"   Call Center Enabled"}
                    </label>
                  </Col>
                  <Col md="3">
                    <label style={{ fontSize: 16 }}>
                      <Field
                        type="checkbox"
                        name="testMode"
                      />
                      {"   Test Mode"}
                    </label>
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <Field
                      type="text"
                      name="disconnectCallInstructions"
                      label="Disconnect Call Instructions"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col>
                    <Field
                      type="text"
                      name="videoURL"
                      label="Video URL"
                      component={ReactstrapInput}
                    />
                  </Col>
                  <Col>
                    <Field
                      type="text"
                      name="videoConnectionInstructions"
                      label="Video Connection Instructions"
                      component={ReactstrapInput}
                    />
                  </Col>
                </Row>

                {!isCompanyOwned && (
                  <div style={{ marginTop: 30, marginBottom: 20 }}>
                    <hr />
                    <h5>Billing</h5>
                    <Row>
                      <Col md="6">
                        <Field
                          name="billingLineType"
                          label="Line"
                          as="select"
                          component={ReactstrapSelect}
                          value={form.values.billingLineType ?? ""}
                          onChange={(event) => form.setFieldValue("billingLineType", event.target.value || null)}
                          inputprops={{
                            name: "billingLineType",
                            id: "billingLineType",
                            options: BILLING_LINE_TYPES.map(type => ({ id: type.value, name: type.label })),
                            defaultOption: "No line subscription",
                          }}
                        />
                      </Col>
                      <Col md="3">
                        <label style={{ marginTop: 25 }}>
                          <Field type="checkbox" name="billingVideo" />
                          {" Video"}
                        </label>
                      </Col>
                      <Col md="3">
                        <label style={{ marginTop: 25 }}>
                          <Field type="checkbox" name="billingCallCenter" />
                          {" Call Center"}
                        </label>
                      </Col>
                    </Row>
                  </div>
                )}

              </>
            )
          }}
        </Field>
      </CrudEdit>
    </>
  );
};

export default Edit;
